<template>
  <div class="bean-page">
    <div class="top-box">
      <div class="title">赚豆攻略</div>
      <div class="rule" @click="showRule">公益豆规则</div>
      <div class="my-bean">
        <div class="l">
          <!-- <img src="@/assets/images/bean/bean.png" alt="" /> -->
          <!-- 我的公益豆 -->特别提示：凭兑换商品二维码在新华慈善超市（地址：法华镇路712号），每兑换一个商品需任意金额（本次消费额不计入公益豆）现金消费一次，即可兑换，购买成功后，需1个月内到慈善超市领取，过期自动作废。
        </div>
        <span class="t"></span>
      </div>
    </div>

    <div class="list">
      <div class="item">
        <div class="l l1"></div>
        <div class="r">
          <div class="top">
            <div>
              <p class="title">时间银行</p>
              <p class="memo">参加时间银行志愿活动，赚取更多公益豆</p>
            </div>
            <div class="arrow">
              <img class="img" src="@/assets/images/w-right-arrow.png" alt="" />
            </div>
          </div>
          <div class="bot">
            1个时间币<span class="t">+10</span>个，每服务一小时<span class="t"
              >+10</span
            >个
          </div>
        </div>
      </div>
      <div class="item">
        <div class="l l2"></div>
        <div class="r">
          <div class="top">
            <div>
              <p class="title">慈善超市购物</p>
              <p class="memo">前往慈善超市购物，赚取更多公益豆</p>
            </div>
            <div class="arrow">
              <img class="img" src="@/assets/images/w-right-arrow.png" alt="" />
            </div>
          </div>
          <div class="bot">每10元<span class="t">+1</span>个</div>
        </div>
      </div>
      <div class="item">
        <div class="l l3"></div>
        <div class="r">
          <div class="top">
            <div>
              <p class="title">献血</p>
              <p class="memo">参加献血活动，赚取更多公益豆</p>
            </div>
            <div class="arrow">
              <img class="img" src="@/assets/images/w-right-arrow.png" alt="" />
            </div>
          </div>
          <div class="bot">每1ml<span class="t">+2.5</span>个</div>
        </div>
      </div>
      <div class="item">
        <div class="l l4"></div>
        <div class="r">
          <div class="top">
            <div>
              <p class="title">现金捐赠</p>
              <p class="memo">参加现金捐赠活动，赚取更多公益豆</p>
            </div>
            <div class="arrow">
              <img class="img" src="@/assets/images/w-right-arrow.png" alt="" />
            </div>
          </div>
          <div class="bot">每1元<span class="t">+2.5</span>个</div>
        </div>
      </div>
      <div class="item">
        <div class="l l5"></div>
        <div class="r">
          <div class="top">
            <div>
              <p class="title">其他志愿服务</p>
              <p class="memo">参加活动，赚取更多公益豆</p>
            </div>
            <div class="arrow">
              <img class="img" src="@/assets/images/w-right-arrow.png" alt="" />
            </div>
          </div>
          <div class="bot">1活力值<span class="t">+0.5</span>个</div>
        </div>
      </div>
      <div class="item">
        <div class="l l6"></div>
        <div class="r">
          <div class="top">
            <div>
              <p class="title">惠老通</p>
              <p class="memo">前往惠老通，获得活力值，兑换公益豆</p>
            </div>
            <div class="arrow">
              <img class="img" src="@/assets/images/w-right-arrow.png" alt="" />
            </div>
          </div>
          <div class="bot">1活力值<span class="t">+0.5</span>个</div>
        </div>
      </div>
      <div class="item">
        <div class="l l7"></div>
        <div class="r">
          <div class="top">
            <div>
              <p class="title">个人捐物</p>
              <p class="memo">前往慈善超市捐物，赚取更多公益豆</p>
            </div>
            <div class="arrow">
              <img class="img" src="@/assets/images/w-right-arrow.png" alt="" />
            </div>
          </div>
          <div class="bot">每1元<span class="t">+1</span>个</div>
        </div>
      </div>
    </div>

    <div class="dialog" v-if="showDiaFlag">
      <div class="con">
        <div class="title">时间银行（志愿服务）</div>
        <div class="mid">
          已在上海志愿者服务网注册，并参加社区
          各类志愿服务活动，正常进行时间银行服 务时间累积。
        </div>
        <div class="btn" @click="call">拨打电话了解详情</div>
        <div class="close" @click="closeRule">
          <img src="@/assets/images/bean/close.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  createApp,
  computed,
  reactive,
  ref,
  onMounted,
  nextTick
} from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  components: {},
  props: {},
  setup(props) {
    const store = useStore()

    const showDiaFlag = ref(false)

    onMounted(() => {})

    const call = () => {}
    const showRule = () => {
      showDiaFlag.value = true
    }
    const closeRule = () => {
      showDiaFlag.value = false
    }
    return {
      showDiaFlag,
      showRule,
      closeRule,
      call
    }
  }
})
</script>
<style lang="scss">
.bean-page {
  min-height: 100vh;
  padding-bottom: 1.2rem;
  background: #f8f8f8;
  .top-box {
    width: 100%;
    height: 5.16rem;
    text-align: center;
    background: url(../../assets/images/bean/bg.png);
    background-size: cover;
    padding-top: 0.98rem;
    .title {
      @include fontSC(0.62rem, #fff);
      margin-bottom: 0.42rem;
    }
    .rule {
      @include fontSC(0.18rem, #fff);
      width: 1.41rem;
      line-height: 0.43rem;
      background: rgba($color: #fff, $alpha: 0.2);
      border-radius: 0.22rem;
      margin: 0 auto 0.28rem;
    }
    .my-bean {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      .l {
        // display: flex;
        // align-items: center;
        @include fontSC(0.18rem, #fff);
        margin-right: 2px;
        padding: 0 0.5rem;
        text-align: left;
        line-height: 1.8em;
        img {
          width: 0.18rem;
          height: 0.17rem;
          margin-right: 2px;
        }
      }
      .t {
        @include fontSC(0.3rem, #fff);
      }
    }
  }

  .list {
    padding: 0 0.25rem;
    margin: -1.45rem auto 0;
    .item {
      border-radius: 0.2rem;
      height: 2.96rem;
      padding: 0 0.26rem;
      display: flex;
      align-items: center;
      margin-bottom: 0.28rem;
      background: #fff;
      .l {
        width: 1.3rem;
        height: 1.4rem;
        margin-right: 0.34rem;
        &.l1 {
          background: url(../../assets/images/love/l1.png);
          background-size: cover;
        }
        &.l2 {
          background: url(../../assets/images/love/l2.png);
          background-size: cover;
        }
        &.l3 {
          background: url(../../assets/images/love/l3.png);
          background-size: cover;
        }
        &.l4 {
          background: url(../../assets/images/love/l4.png);
          background-size: cover;
        }
        &.l5 {
          background: url(../../assets/images/love/l5.png);
          background-size: cover;
        }
        &.l6 {
          background: url(../../assets/images/love/l6.png);
          background-size: cover;
        }
        &.l7 {
          background: url(../../assets/images/love/l7.png);
          background-size: cover;
        }
        &.l8 {
          background: url(../../assets/images/love/l8.png);
          background-size: cover;
        }
      }

      .r {
        flex: 1;
        .top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .title {
            @include fontSC(0.4rem, #333);
            margin-bottom: 0.2rem;
          }
          .memo {
            @include fontSC(0.22rem, #999);
          }
          .arrow {
            width: 0.49rem;
            height: 0.49rem;
            background: #f65341;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.25rem;
            img {
              width: 0.116rem;
              height: 0.21rem;
            }
          }
        }
        .bot {
          margin-top: 0.45rem;
          .t {
            @include fontSC(0.22rem, #f65341);
          }
        }
      }
    }
  }

  .dialog {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    .con {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -52%);
      background: #fff;
      width: 6.3rem;
      border-radius: 0.2rem;

      padding: 0.65rem 0.45rem 0.92rem;
      .title {
        @include fontSC(0.38rem, #333);
        font-weight: bold;
        text-align: center;
      }
      .mid {
        @include fontSC(0.3rem, #666);
        line-height: 1.5em;
        margin: 0.3rem 0;
      }
      .btn {
        @include fontSC(0.3rem, #f65341);
      }
      .close {
        position: absolute;
        top: 0.27rem;
        right: 0.27rem;
        width: 0.39rem;
        height: 0.39rem;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
